/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Why_EquipmentInputs */

const en_us2_profile_why_equipment = /** @type {(inputs: Profile_Why_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only what you can do where you train makes it into the plan.`)
};

const pt_br2_profile_why_equipment = /** @type {(inputs: Profile_Why_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só entra no plano o que você consegue fazer onde treina.`)
};

const es_419_profile_why_equipment = /** @type {(inputs: Profile_Why_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo entra al plan lo que puedes hacer donde entrenas.`)
};

const pt_pt2_profile_why_equipment = /** @type {(inputs: Profile_Why_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só entra no plano o que consegues fazer onde treinas.`)
};

const fr_fr2_profile_why_equipment = /** @type {(inputs: Profile_Why_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seul ce que tu peux faire là où tu t'entraînes entre dans le programme.`)
};

const de_de2_profile_why_equipment = /** @type {(inputs: Profile_Why_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur was du dort machen kannst, wo du trainierst, kommt in den Plan.`)
};

const it_it2_profile_why_equipment = /** @type {(inputs: Profile_Why_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nella scheda entra solo quello che puoi fare dove ti alleni.`)
};

/**
* | output |
* | --- |
* | "Only what you can do where you train makes it into the plan." |
*
* @param {Profile_Why_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_why_equipment = /** @type {((inputs?: Profile_Why_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Why_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_why_equipment(inputs)
	if (locale === "es-419") return es_419_profile_why_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_why_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_why_equipment(inputs)
	if (locale === "de-DE") return de_de2_profile_why_equipment(inputs)
	if (locale === "it-IT") return it_it2_profile_why_equipment(inputs)
	return en_us2_profile_why_equipment(inputs)
});
export { profile_why_equipment as "profile.why_equipment" }